(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/common/directives/loadingAnimationDirective.tpl.html',
    '<div class="loading-animation-dsa"><div class="loading-bar-dsa"></div><div class="loading-bar-dsa"></div><div class="loading-bar-dsa"></div><div class="loading-bar-dsa"></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/loadingAnimationDirective.tpl.js